export function UpdateQueryParameter(key: string, value: string) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // Update only if the parameter is already presented
    if (!params.has(key)) {
        return;
    }
    params.set(key, value);
    url.search = params.toString();
    window.history.replaceState(null, '', url.toString());
}